export default __webpack_public_path__ + "static/map-banner-b9820a17366a77a8fa3ca3306739642a.png";